// 社労士事務所の全サービスリスト
// microCMSの選択肢と完全一致させる必要があります

export const ALL_SERVICES = [
  '労務管理コンサルティング',
  '就業規則・各種規程作成',
  '36協定対応',
  '変形労働時間制対応',
  '社会保険・労働保険手続き',
  '給与計算代行',
  '労務監査・リスク診断',
  '労働条件通知書作成',
  '年休管理簿作成',
  'セミナー・研修実施',
  '労働トラブル対応',
  '人事制度設計',
  '採用支援',
  '助成金申請サポート',
];

// サービスのカテゴリ分け（オプション）
export const SERVICE_CATEGORIES = {
  '労務管理': [
    '労務管理コンサルティング',
    '就業規則・各種規程作成',
    '36協定対応',
    '変形労働時間制対応',
    '労働条件通知書作成',
    '年休管理簿作成',
  ],
  '手続き代行': [
    '社会保険・労働保険手続き',
    '給与計算代行',
    '助成金申請サポート',
  ],
  'コンサルティング': [
    '労務監査・リスク診断',
    '労働トラブル対応',
    '人事制度設計',
    '採用支援',
  ],
  '教育・研修': [
    'セミナー・研修実施',
  ],
};
